(function () {
	'use strict';

	if (window.__variantCompTableInit) return;
	window.__variantCompTableInit = true;

	function init() {
		var table = document.querySelector('[data-vct]');
		if (!table) return;

		var tbody = table.querySelector('tbody');
		var rows = table.querySelectorAll('[data-vct-row]');
		var subtotalEl = table.querySelector('[data-vct-subtotal]');
		var countEl = table.querySelector('[data-vct-count]');
		var addButton = table.querySelector('[data-vct-add-to-basket]');
		var errorEl = table.querySelector('[data-vct-error]');
		var resetBtn = table.querySelector('[data-vct-reset]');
		var currencyFormat = table.getAttribute('data-vct-currency-format') || '£{{amount}}';
		var productId = table.getAttribute('data-vct-product-id') || '';
		var storageKey = productId ? 'vct-qtys:' + productId : '';

		function formatMoney(cents) {
			if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
				return window.Shopify.formatMoney(cents, currencyFormat);
			}
			var amount = (cents / 100).toFixed(2);
			return currencyFormat.replace('{{amount}}', amount);
		}

		function readQty(input) {
			var qty = parseInt(input.value, 10);
			if (isNaN(qty) || qty < 0) qty = 0;
			return qty;
		}

		// MOQ rule for a row, read from data-moq/data-inc (printed by moq-rule.liquid).
		function ruleOf(input) {
			var moq = parseInt(input.getAttribute('data-moq'), 10);
			var inc = parseInt(input.getAttribute('data-inc'), 10);
			if (!moq || moq < 1) moq = 1;
			if (!inc || inc < 1) inc = 1;
			return { moq: moq, inc: inc };
		}

		function maxOf(input) {
			var m = parseInt(input.getAttribute('max'), 10);
			return (!isNaN(m) && m > 0) ? m : Infinity;
		}

		// A row qty is valid when it is 0 (not ordering) OR meets the MOQ + increment.
		function isValidQty(qty, rule) {
			if (qty === 0) return true;
			if (qty < rule.moq) return false;
			return (qty - rule.moq) % rule.inc === 0;
		}

		function readStoredQtys() {
			if (!storageKey) return {};
			try {
				var raw = window.localStorage.getItem(storageKey);
				if (!raw) return {};
				var parsed = JSON.parse(raw);
				return (parsed && typeof parsed === 'object') ? parsed : {};
			} catch (e) {
				return {};
			}
		}

		function writeStoredQtys(obj) {
			if (!storageKey) return;
			try {
				if (!obj || Object.keys(obj).length === 0) {
					window.localStorage.removeItem(storageKey);
				} else {
					window.localStorage.setItem(storageKey, JSON.stringify(obj));
				}
			} catch (e) {
				/* quota exceeded / private mode — silent fail */
			}
		}

		function persistFromInputs() {
			var snapshot = {};
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				var input = row.querySelector('[data-vct-qty]');
				if (!input) continue;
				var qty = readQty(input);
				if (qty > 0) {
					snapshot[row.getAttribute('data-variant-id')] = qty;
				}
			}
			writeStoredQtys(snapshot);
		}

		function restoreQtysFromStorage() {
			var stored = readStoredQtys();
			if (!stored || Object.keys(stored).length === 0) return;
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				var input = row.querySelector('[data-vct-qty]');
				if (!input) continue;
				var vid = row.getAttribute('data-variant-id');
				if (Object.prototype.hasOwnProperty.call(stored, vid)) {
					input.value = String(stored[vid]);
				}
			}
		}

		function updateSubtotal() {
			var totalCents = 0;
			var totalCount = 0;
			var anyInvalid = false;
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				var input = row.querySelector('[data-vct-qty]');
				if (!input) continue;
				var qty = readQty(input);
				var valid = isValidQty(qty, ruleOf(input));
				input.classList.toggle('vct-qty-invalid', !valid);
				input.setAttribute('aria-invalid', valid ? 'false' : 'true');
				if (!valid) anyInvalid = true;
				var price = parseInt(row.getAttribute('data-price-cents'), 10) || 0;
				totalCents += qty * price;
				totalCount += qty;
			}
			if (subtotalEl) subtotalEl.textContent = formatMoney(totalCents);
			if (countEl) countEl.textContent = String(totalCount);
			if (anyInvalid) {
				showMoqError();
			} else {
				clearError();
			}
			if (addButton) {
				addButton.disabled = totalCount === 0 || anyInvalid;
			}
			if (resetBtn) {
				if (totalCount > 0) {
					resetBtn.removeAttribute('hidden');
				} else {
					resetBtn.setAttribute('hidden', '');
				}
			}
		}

		function onQtyChange() {
			updateSubtotal();
			persistFromInputs();
		}

		function clearError() {
			if (errorEl) {
				errorEl.textContent = '';
			}
		}

		function showError(message) {
			if (errorEl) {
				errorEl.textContent = "Couldn't add to basket: " + message + '. Please adjust quantities and try again.';
			}
		}

		function showMoqError() {
			if (errorEl) {
				errorEl.textContent = 'Some quantities don’t meet the minimum order or pack multiple. Adjust the highlighted rows.';
			}
		}

		function resetAllQty() {
			for (var i = 0; i < rows.length; i++) {
				var input = rows[i].querySelector('[data-vct-qty]');
				if (input) input.value = '0';
			}
			updateSubtotal();
			writeStoredQtys({});
		}

		function triggerCartDrawer() {
			if (typeof ajaxCart === 'undefined' || !ajaxCart || typeof ajaxCart.load !== 'function') return;
			var drawerEnabled = (typeof general === 'undefined') || general.enable_cart_drawer !== false;
			if (drawerEnabled) {
				ajaxCart.load();
			} else {
				ajaxCart.load(false, true, false, true);
			}
		}

		function addToBasket() {
			clearError();
			var items = [];
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				var input = row.querySelector('[data-vct-qty]');
				if (!input) continue;
				var qty = readQty(input);
				if (qty <= 0) continue;
				if (!isValidQty(qty, ruleOf(input))) {
					// Shouldn't happen (Add is disabled while invalid), but guard the bulk add.
					updateSubtotal();
					return;
				}
				var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
				if (!variantId) continue;
				items.push({ id: variantId, quantity: qty });
			}
			if (items.length === 0) return;

			addButton.disabled = true;
			addButton.classList.add('vct-loading');

			fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
				body: JSON.stringify({ items: items })
			})
				.then(function (response) {
					if (!response.ok) {
						return response.json().then(function (err) { throw err; });
					}
					return response.json();
				})
				.then(function () {
					triggerCartDrawer();
					resetAllQty();
					addButton.classList.remove('vct-loading');
				})
				.catch(function (err) {
					var message = (err && err.description) || (err && err.message) || 'Network error';
					showError(message);
					addButton.disabled = false;
					addButton.classList.remove('vct-loading');
				});
		}

		// Wire up per-row events
		for (var i = 0; i < rows.length; i++) {
			(function (row) {
				var input = row.querySelector('[data-vct-qty]');
				var minusBtn = row.querySelector('[data-vct-minus]');
				var plusBtn = row.querySelector('[data-vct-plus]');

				if (input) {
					input.addEventListener('change', onQtyChange);
					input.addEventListener('input', onQtyChange);
				}
				if (minusBtn) {
					minusBtn.addEventListener('click', function (e) {
						e.preventDefault();
						if (!input) return;
						var rule = ruleOf(input);
						var qty = readQty(input);
						var next;
						if (qty <= rule.moq) {
							next = 0; // stepping below the MOQ removes the row
						} else {
							next = qty - rule.inc;
							if (next < rule.moq) next = rule.moq; // never land between 0 and MOQ
						}
						input.value = String(next);
						onQtyChange();
					});
				}
				if (plusBtn) {
					plusBtn.addEventListener('click', function (e) {
						e.preventDefault();
						if (!input) return;
						var rule = ruleOf(input);
						var max = maxOf(input);
						var qty = readQty(input);
						var next = (qty < rule.moq) ? rule.moq : qty + rule.inc; // first step jumps to MOQ
						if (next > max) next = qty; // don't exceed available stock
						input.value = String(next);
						onQtyChange();
					});
				}

				// Mobile card expand/collapse. The thumb/SKU/options links
				// navigate to the variant page and the qty stepper keeps its
				// own behaviour; a tap anywhere else on the card (including
				// the chevron) toggles the details dropdown.
				var toggleBtn = row.querySelector('[data-vct-card-toggle]');
				function toggleCard() {
					var open = !row.classList.contains('vct-card-open');
					if (open) {
						row.classList.add('vct-card-open');
					} else {
						row.classList.remove('vct-card-open');
					}
					if (toggleBtn) toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
				}
				if (toggleBtn) {
					toggleBtn.addEventListener('click', function (e) {
						e.preventDefault();
						e.stopPropagation();
						toggleCard();
					});
				}
				row.addEventListener('click', function (e) {
					if (window.innerWidth > 768) return;
					var t = e.target;
					if (t && t.closest && t.closest('a, button, input')) return;
					toggleCard();
				});
			})(rows[i]);
		}

		if (addButton) {
			addButton.addEventListener('click', function (e) {
				e.preventDefault();
				addToBasket();
			});
		}

		if (resetBtn) {
			resetBtn.addEventListener('click', function (e) {
				e.preventDefault();
				resetAllQty();
			});
		}

		// Load more / reveal hidden rows in chunks.
		var loadMoreBtn = table.querySelector('[data-vct-load-more]');
		var loadMoreWrap = table.querySelector('[data-vct-load-more-wrap]');
		if (loadMoreBtn) {
			var chunkSize = parseInt(loadMoreBtn.getAttribute('data-vct-chunk-size'), 10);
			if (isNaN(chunkSize) || chunkSize <= 0) chunkSize = 10;
			loadMoreBtn.addEventListener('click', function (e) {
				e.preventDefault();
				var hidden = table.querySelectorAll('.vct-row-hidden');
				var reveal = Math.min(chunkSize, hidden.length);
				for (var i = 0; i < reveal; i++) {
					hidden[i].classList.remove('vct-row-hidden');
				}
				var remaining = hidden.length - reveal;
				if (remaining > 0) {
					var nextChunk = Math.min(chunkSize, remaining);
					loadMoreBtn.textContent = 'Show ' + nextChunk + ' more option' + (nextChunk !== 1 ? 's' : '');
				} else {
					loadMoreBtn.setAttribute('aria-expanded', 'true');
					if (loadMoreWrap) loadMoreWrap.style.display = 'none';
				}
			});
		}

		// Column sort. Click a sortable header to sort tbody rows by that
		// column's value. Reveals any hidden rows and hides the load-more
		// button since the post-sort order doesn't map to the original
		// "first 7" pattern.
		var sortableHeaders = table.querySelectorAll('thead th[data-vct-sortable]');
		var currentSortHeader = null;
		var currentSortDir = '';

		function cellValue(row, colIdx, sortType) {
			if (sortType === 'price') {
				return parseFloat(row.getAttribute('data-price-cents')) || 0;
			}
			var cells = row.children;
			var cell = cells[colIdx];
			if (!cell) return sortType === 'text' ? '' : 0;
			var text = (cell.textContent || '').trim();
			if (sortType === 'text') return text.toLowerCase();
			// auto: try number first, fall back to text
			var num = parseFloat(text.replace(/[^0-9.\-]/g, ''));
			if (!isNaN(num) && /[0-9]/.test(text)) return num;
			return text.toLowerCase();
		}

		function sortBy(header) {
			if (!tbody) return;
			var colIdx = Array.prototype.indexOf.call(header.parentNode.children, header);
			var sortType = header.getAttribute('data-vct-sort-type') || 'auto';
			var dir;
			if (currentSortHeader === header) {
				dir = currentSortDir === 'asc' ? 'desc' : 'asc';
			} else {
				dir = 'asc';
			}
			var rowArr = Array.prototype.slice.call(tbody.children);
			rowArr.sort(function (a, b) {
				var av = cellValue(a, colIdx, sortType);
				var bv = cellValue(b, colIdx, sortType);
				if (av < bv) return dir === 'asc' ? -1 : 1;
				if (av > bv) return dir === 'asc' ? 1 : -1;
				return 0;
			});
			// Reveal any hidden rows + hide load-more since order is now custom
			for (var i = 0; i < rowArr.length; i++) {
				rowArr[i].classList.remove('vct-row-hidden');
				tbody.appendChild(rowArr[i]);
			}
			if (loadMoreWrap) loadMoreWrap.style.display = 'none';
			// Update sort indicator classes
			for (var j = 0; j < sortableHeaders.length; j++) {
				sortableHeaders[j].classList.remove('vct-sort-asc', 'vct-sort-desc');
			}
			header.classList.add(dir === 'asc' ? 'vct-sort-asc' : 'vct-sort-desc');
			currentSortHeader = header;
			currentSortDir = dir;
		}

		for (var s = 0; s < sortableHeaders.length; s++) {
			(function (h) {
				h.addEventListener('click', function () { sortBy(h); });
			})(sortableHeaders[s]);
		}

		// Restore persisted qtys before first subtotal update
		restoreQtysFromStorage();
		updateSubtotal();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
